import { render, staticRenderFns } from "./DynamicModal.vue?vue&type=template&id=4aba7aca&scoped=true"
import script from "./DynamicModal.vue?vue&type=script&lang=js"
export * from "./DynamicModal.vue?vue&type=script&lang=js"
import style0 from "./DynamicModal.vue?vue&type=style&index=0&id=4aba7aca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aba7aca",
  null
  
)

export default component.exports